export const API_URL = "https://dnarchive-server-dervm.ondigitalocean.app/";

export const DRAWER_WIDTH = {
  OPEN: 170,
  CLOSED: 60,
};

export const CHROMOSOMES = [
  "Chr 1",
  "Chr 2",
  "Chr 3",
  "Chr 4",
  "Chr 5",
  "Chr 6",
  "Chr 7",
  "Chr 8",
  "Chr 9",
  "Chr 10",
  "Chr 11",
  "Chr 12",
  "Chr 13",
  "Chr 14",
  "Chr 15",
  "Chr 16",
  "Chr 17",
  "Chr 18",
  "Chr 19",
  "Chr 20",
  "Chr 21",
  "Chr 22",
  "Chr X",
  "Chr Y",
];
